module.exports = __webpack_public_path__ + "img/company_logo_bw.db04dd13.png";